/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import BlockLayouts from '../../../components/block-layouts';

import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	'Gutenify/Block/Info-Box/InspectorControls/BasicControls/tabs/content',
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'info-box',
						initialOpen: true,
						label: () => {
							return __( 'Info Box' );
						},
						cb: () => {
							return <>
								<BlockLayouts layouts={ layouts } value={ layout } blockName={ hookPrefix } onChange={ ( val ) => {
									const data = {
										layout: val.name,
										iconAlign: val.iconAlign,
										titleAlign: val.titleAlign,
									};
									setAttributes( data );
									updateInnerBlocks( val );
								} } />
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
